import React from 'react'
import { observer } from "mobx-react-lite";
import clickupLogo from "../../../images/clickup.png";
import { useContext, useEffect, useState } from "react";
import ClickUpStore from "../../store/ClickUpStore";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import RecordService from "../../service/recordService";
import AuthStore from "../../store/AuthStore";
import ZoomContext from "../../store/ZoomStore";
import UpdateStream from './content/UpdateStream';
import RoundTable from './content/RoundTable';
import { useNavigate } from 'react-router-dom';
import ZoomRecording from '../../recording/ZoomRecording';
import UserCallService from "../../service/userCallService";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        mt: 1
      }}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

const ClickUpContainer = () => {
  const navigate = useNavigate()
  let authStore = useContext(AuthStore);
  let store = useContext(ClickUpStore);
  let recordService = new RecordService(authStore)
  let zoomStore = useContext(ZoomContext);
  let selectedList = store.getListById(store.selectedListId);
	let userService = new UserCallService(authStore);
  const [value, setValue] = React.useState(store.selectedTab);

  const onConfirmListButtonClick = async () => {
    try {
      const result = await userService.selectClickUpList(store.selectedListId, zoomStore.meetingUUID);
      if (result === false) {
        setTimeout(onConfirmListButtonClick, 10000);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setTimeout(onConfirmListButtonClick, 10000);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    store.setSelectedTab(newValue)
  };

  const handleApplyChange = (changedTask) => {

    const data = { ...changedTask };
    data.taskChanges = changedTask.taskChanges.filter(change => change.field !== "Progress");

    recordService.applyChanges(changedTask)
      .then(data => {
        console.log(data);
      })
      .catch((error) => {
        store.setIsRequestInProgress(false)
        if (!error || !error.response || error.response.status === 401) {
          navigate("/")
        }
      })
  }

  const [roundTableData, setRoundTableData] = useState([])
  const [streamData, setStreamData] = useState("")
  const [timerId, setTimerId] = useState()
  useEffect(() => {
    if (store.selectedListId === null && zoomStore.meetingUUID === "") {
      navigate("/list")
    }
    else {
      onConfirmListButtonClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, store.selectedListId, zoomStore.meetingUUID])

  useEffect(() => {
    let id = setInterval(requestHandler, 10000)
    setTimerId(id)

    let id1 = setInterval(commandHandler, 3000)
    setTimerId(id1)
    return () => {
      clearInterval(id)
      clearInterval(id1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const commandHandler = () => {
    if(store.selectedTab === 0) {
      recordService.getCommandStatus("ClickUp", store.selectedListId, zoomStore.meetingUUID)
      .then(data => {
        if( data === true ) {
          recordService.getUpdateStream("ClickUp", store.selectedListId, zoomStore.meetingUUID)
          .then(data => {
            setStreamData(data)
            store.setIsRequestInProgress(false)
          })
          .catch((error) => {
            store.setIsRequestInProgress(false)
            if (!error || error.response.status === 401) {
              navigate("/")
            }
          })
        }
      })
      .catch((error) => {
        store.setIsRequestInProgress(false)
        if (!error || !error.response || error.response.status === 401) {
          navigate("/")
        }
      })
    }
  }

  const requestHandler = () => {
    console.log(store.selectedTab);
    if (store.selectedTab === 2) {
      recordService.getRoundTableData("ClickUp", store.selectedListId, zoomStore.meetingUUID)
        .then(data => {
          setRoundTableData(data.length > 0 ? data[data.length - 1] : {})
          store.setIsRequestInProgress(false)
        })
        .catch((error) => {
          store.setIsRequestInProgress(false)
          if (!error || !error.response || error.response.status === 401) {
            navigate("/")
          }
        })
    } else if(store.selectedTab === 1) {
      recordService.getUpdateStream("ClickUp", store.selectedListId, zoomStore.meetingUUID)
        .then(data => {
          setStreamData(data)
          store.setIsRequestInProgress(false)
        })
        .catch((error) => {
          store.setIsRequestInProgress(false)
          if (!error || error.response.status === 401) {
            navigate("/")
          }
        })
    }
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const inActiveCSS = {
    fontFamily: 'Mona Sans',
    fontWeight: 600,
    textTransform: 'none',
    px: 3,
    py: 1.5,
    maxHeight: 40,
    minHeight: 40,
    color: `rgba(24, 28, 48, 0.48)`,
    fontSize: 14
  }

  const activeCSS = {
    fontFamily: 'Mona Sans',
    fontWeight: 600,
    textTransform: 'none',
    px: 3,
    py: 1.5,
    maxHeight: 40,
    minHeight: 40,
    color: `rgba(185, 121, 249, 1) !important`,
    fontSize: 14,
    bgcolor: 'white',
    boxShadow: `0px 2px 8px 0px rgba(24, 28, 48, 0.1)`,
    borderRadius: '14px'
  }

  return (
    <Box display='flex' justifyContent='center'>
      <Box px={2} py={3} width={356} gap={3} display='flex' flexDirection='column'>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box display='flex' alignItems='center'>
            <img src={clickupLogo} alt="" />
            <Typography sx={{
              color: "#181C30",
              ml: 0.5,
              fontSize: "12px",
              fontWeight: 600
            }}>{selectedList?.name}</Typography>
          </Box>
          <Typography sx={{
            color: "#181C30",
            fontSize: "12px",
            cursor: 'pointer'
          }} onClick={() => {
            store.setSelectedTab(value)
            clearInterval(timerId)
            navigate('/tasks')
          }}>
            Tasks in this list →
          </Typography>
        </Box>
        <Box>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{
            bgcolor: 'rgba(24, 28, 48, 0.04)',
            borderRadius: '18px',
            width: 324,
            p: 0.5,
          }}>
            <Tab label="Command" {...a11yProps(0)} sx={{...(value === 0 ? activeCSS : inActiveCSS), width: 90, padding: '12px', fontSize: 11}} />
            <Tab label="Update Stream" {...a11yProps(1)} sx={{...(value === 1 ? activeCSS : inActiveCSS), width: 110, padding: '12px', fontSize: 11}} />
            <Tab label="Task Roundtable" {...a11yProps(2)} sx={{...(value === 2 ? activeCSS : inActiveCSS), width: 120, padding: '12px', fontSize: 11}} />
          </Tabs>
          <CustomTabPanel value={value} index={0}>
            <UpdateStream data={streamData} handleUpdate={handleApplyChange}/>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <UpdateStream data={streamData}  handleUpdate={handleApplyChange}/>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <RoundTable data={roundTableData}  handleUpdate={handleApplyChange}/>
          </CustomTabPanel>
        </Box>
        <ZoomRecording />
      </Box>
    </Box>
  )
}

export default observer(ClickUpContainer);